import request from '@/utils/request';

const areaName = sessionStorage.getItem('areaName') || '510000';

// 获取政策信息
export function getPolicy(data) {
  return request({
    url: '/plicy/query/web',
    method: 'POST',
    data: { ...data, name: areaName },
  });
}

// 政策信息详情
export function getPolicyDetail(id) {
  return request({
    url: `/plicy/query/${id}`,
    method: 'GET',
  });
}

// 获取政策明白卡
export function getPolicyCardList(data) {
  return request({
    url: '/plicy/card/query/web',
    method: 'POST',
    data: { ...data },
  });
}

// 获取政策明白卡详情
export function getPolicyCardDetail(id) {
  return request({
    url: `/plicy/card/query/${id}`,
    method: 'GET',
  });
}

// 申请查看政策要点
export function applyView(data) {
  return request({
    url: '/plicy/card/add/examine',
    method: 'POST',
    data,
  });
}
